import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';

import './range-slider.scss';

export function RangeSlider({
  className,
  onChange = noop,
  min = 0,
  max = 100,
  step = 1,
  defaultValue = 0,
  ...restProps
}) {
  const [backgroundPercents, setBackgroundPercents] = useState(((defaultValue - min) * 100) / (max - min));

  const onRangeChange = useCallback(
    e => {
      const {
        target: { value },
      } = e;

      setBackgroundPercents(((value - min) * 100) / (max - min));
      onChange(value, e);
    },
    [onChange, min, max]
  );

  return (
    <input
      type="range"
      {...restProps}
      min={min}
      max={max}
      step={step}
      defaultValue={defaultValue}
      className={classnames('range-slider', className)}
      onChange={onRangeChange}
      style={{
        backgroundImage: `linear-gradient(90deg, #0069bf ${backgroundPercents}%, transparent ${backgroundPercents}%), linear-gradient(0deg, rgba(0, 0, 0, 0.43) 50%, transparent 50%)`,
      }}
    />
  );
}

RangeSlider.propTypes = {
  onChange: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  defaultValue: PropTypes.number,
};
